import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-[#F7F5F0]" data-id="element-156">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-158">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mb-8 text-center" data-id="element-159">
            El Verdadero Problema
          </h2>

          <div className="space-y-6" data-id="element-160">
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-161">
              La mayoría de los aplicantes cometen el error de estudiar con
              listas interminables de internet que están desactualizadas o que
              no incluyen la traducción exacta de lo que el oficial realmente
              dirá.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-162">
              El problema no es tu memoria, es el sistema de estudio. Intentar
              memorizar 100 preguntas sueltas sin entender el contexto te genera
              una confusión mental que explota en el momento de la entrevista.
            </p>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.2
          }} className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-lg" data-id="element-163">
              <div className="flex items-start gap-3" data-id="element-164">
                <AlertTriangleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-165" />
                <p className="text-red-900 font-semibold" data-id="element-166">
                  Un simple "Yes" o "No" mal dicho en las preguntas de moralidad
                  (N-400) puede arruinar años de espera.
                </p>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}